/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Alarms_Actions_Selecthistory1Inputs */



/**
* | output |
* | --- |
* | "Select {name}" |
*
* @param {Alarms_Actions_Selecthistory1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_actions_selecthistory1 = /** @type {((inputs: Alarms_Actions_Selecthistory1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Actions_Selecthistory1Inputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Select ${i?.name}`)
	return /** @type {LocalizedString} */ (`Sélectionner ${i?.name}`)
});
export { alarms_actions_selecthistory1 as "alarms_actions_selectHistory" }